import { Request as BaseRequest } from '../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: [] as const,
	columnFields: [] as const,
	standardFilterFields: [] as const,
	dateFilterFields: [] as const,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
